<div
    class="lotam-details"
    [ngClass]="{ 'lotam-blocked': status === MissionNoticeDto.Status.BLOCK }"
>
    <div class="result-container">
        <div class="lotam-selector">
            <div class="vertical-container fill">
                <div class="fill">
                    <strong>
                        {{ lotam.subject }}
                    </strong>
                </div>
                <div class="horizontal-container wrap fill parameter-summary">
                    <div>
                        {{
                            lotam.startTime
                                | formatDateRange
                                    : lotam.endTime
                                    : organisation.timeZone
                        }}
                    </div>
                    <div>
                        {{ lotam.lowerLimit | formatAltitudeValue: 'SFC' }} -
                        {{
                            lotam.upperLimit | formatAltitudeValue: 'Unlimited'
                        }}
                    </div>
                </div>
                <div
                    class="horizontal-container vertical-align wrap fill parameter-summary top-buffer"
                >
                    <span
                        class="status-block"
                        [ngClass]="status | noticeStatusClass: isAcknowledged"
                    >
                        {{ status | formatNoticeStatusName: isAcknowledged }}
                    </span>
                    <notice-type-list-item
                        *ngIf="lotam.noticeType"
                        [noticeType]="lotam.noticeType"
                    ></notice-type-list-item>
                </div>
            </div>
            <div
                class="horizontal-container vertical-align lotam-actions-container"
            >
                <button
                    type="button"
                    class="btn btn-xs btn-pill btn-primary left-buffer"
                    tooltip="View and acknowledge LOTAM"
                    placement="top"
                    (click)="viewLotamDetail()"
                >
                    {{ buttonText }}
                </button>
                <div
                    style="line-height: 37px"
                    class="no-wrap"
                    *ngIf="locationBearing != null"
                >
                    <span [innerHtml]="locationBearing | bearing"></span>
                </div>
            </div>
        </div>
    </div>
</div>
